export default "__VITE_ASSET__CQmRZ9o2__"